import { render } from "./HeroTitle.vue?vue&type=template&id=accbcbc2&scoped=true"
import script from "./HeroTitle.vue?vue&type=script&lang=js"
export * from "./HeroTitle.vue?vue&type=script&lang=js"

import "./HeroTitle.vue?vue&type=style&index=0&id=accbcbc2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tunescrib-rs/tunescrib-rs/dev.tunescrib.com-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-accbcbc2"]])

export default __exports__